import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";

@Injectable({
    providedIn: 'root'
})
export class LoaderService {
    //#region properties

    //#region private
    private _activeRequest: number = 0;
    private _loaderVisibleSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    //#endregion

    //#endregion

    //#region setters
    public set loaderVisible(value: boolean) {
        this._loaderVisibleSubject.next(value);
    }
    //#endregion

    //#region getters
    public get loaderVisible() {
        return this._loaderVisibleSubject.value;
    }

    public get loaderVisible$(): Observable<boolean> {
        return this._loaderVisibleSubject.asObservable();
    }
    //#endregion

    //#region ctor
    //#endregion

    //#region private actions
    //#endregion

    //#region public actions
    public showLoader() {
        this._activeRequest++;
        this._loaderVisibleSubject.next(true);
    }

    public hideLoader() {
        this._activeRequest--;
        if(this._activeRequest <= 0) {
            this._activeRequest = 0;
            this._loaderVisibleSubject.next(false);
        }
    }

    public forceHideLoader() {
        this._activeRequest = 0;
        this._loaderVisibleSubject.next(false);
    }
    //#endregion
}